<div class="modal">
  <h2 mat-dialog-title>{{ 'EDIT_REPORT.EDIT_PRIMARY_BUTTON' | translate }}</h2>
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <mat-dialog-content class="bottom-spacing">
      <div class="row" *ngIf="(loading$$ | async) === false; else loading">
        <div class="col col-sm-12 col-md-6">
          <div class="form-field">
            <glxy-input
              [label]="'EDIT_REPORT.CUSTOM_BUTTON_TEXT' | translate"
              [(ngModel)]="label"
              [ngModelOptions]="{ standalone: true }"
              [value]="label | translate"
            ></glxy-input>
          </div>

          <span class="radio-group-label row">
            {{ 'EDIT_REPORT.RADIO_GROUP_LABEL' | translate }}
          </span>
          <mat-radio-group [(ngModel)]="selectedCtaTargetOption" [ngModelOptions]="{ standalone: true }" class="row">
            <mat-radio-button
              [value]="0"
              (change)="resetNoSelectedTargetCtaOptions($event)"
              class="contact-us-radio col col-sm-12"
              value="default"
            >
              {{ 'EDIT_REPORT.CONTACT_US_FORM' | translate }}
            </mat-radio-button>
            <mat-radio-button
              *ngIf="marketplaceProducts$$ | async as marketplaceProducts"
              [value]="1"
              (change)="resetNoSelectedTargetCtaOptions($event)"
              class="radio-alignment col col-sm-12"
              [disabled]="marketplaceProducts.length <= 0"
            >
              <mat-form-field class="form-field cta-target-input" appearance="outline">
                <mat-label>{{ 'EDIT_REPORT.PACKAGE' | translate }}</mat-label>
                <mat-select
                  [(ngModel)]="targetProduct"
                  [ngModelOptions]="{ standalone: true }"
                  (selectionChange)="validateSelectedProduct(this.selectedCtaTargetOption)"
                >
                  <mat-select-trigger>
                    <div class="selected-product">
                      <img *ngIf="targetProduct?.icon" [src]="targetProduct?.icon" class="product-icon" />
                      <mat-icon *ngIf="!targetProduct?.icon">store</mat-icon>
                      <span>{{ targetProduct?.name }}</span>
                    </div>
                  </mat-select-trigger>
                  <mat-option [disabled]="true" *ngIf="marketplaceProducts.length <= 0">
                    {{ 'EDIT_REPORT.NO_PACKAGES_IN_STORE' | translate }}
                  </mat-option>
                  <mat-option *ngFor="let product of marketplaceProducts" [value]="product">
                    <img *ngIf="product.icon" [src]="product.icon" class="product-icon" />
                    <mat-icon *ngIf="!product.icon">store</mat-icon>
                    {{ product.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </mat-radio-button>
            <mat-radio-button [value]="2" (change)="resetNoSelectedTargetCtaOptions($event)" class="col col-sm-12">
              <div class="form-field cta-target-input">
                <glxy-input
                  [label]="'EDIT_REPORT.CUSTOM_BUTTON_URL' | translate"
                  [(ngModel)]="targetUrl"
                  (ngModelChange)="validateCustomUrl(this.selectedCtaTargetOption)"
                  (focus)="onFocusTargetUrlInput()"
                  [ngModelOptions]="{ standalone: true }"
                ></glxy-input>
              </div>
            </mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="isProductInvalid">
            {{ 'EDIT_REPORT.ERRORS.PACKAGE_ID_INVALID' | translate }}
            <mat-icon class="error-icon">error</mat-icon>
          </mat-error>
          <mat-error *ngIf="isUrlInvalid">
            {{ 'EDIT_REPORT.ERRORS.CUSTOM_URL_INVALID' | translate }}
            <mat-icon class="error-icon">error</mat-icon>
          </mat-error>
          <mat-error *ngIf="isProductAvailable === false">
            {{ 'EDIT_REPORT.ERRORS.DEACTIVATED_PACKAGE_ID' | translate }}
            <mat-icon class="error-icon">error</mat-icon>
          </mat-error>
        </div>
        <div class="col col-sm-12 col-md-6 preview">
          <div class="preview-label">
            {{ 'EDIT_REPORT.BUTTON_PREVIEW' | translate }}
          </div>
          <button type="button" class="button-preview" mat-flat-button color="primary" (click)="navigateToURL()">
            {{ label || (defaultLabel | translate) }}
          </button>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button color="primary" type="button" (click)="cancel()">
        {{ 'COMMON.CANCEL' | translate }}
      </button>
      <button mat-flat-button color="primary" type="submit" [disabled]="isUrlInvalid || isProductInvalid">
        {{ 'COMMON.SAVE' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</div>

<ng-template #loading>
  <glxy-loading-spinner [fullWidth]="true"></glxy-loading-spinner>
</ng-template>
